module.exports = __webpack_public_path__ + "img/booking_list.396b78ab.svg";